import { OwcTypography, OwcProgressBar, OwcInput } from '@one/react';
import Banner from '../../../../components/Common/Banner';
import styles from './DeprecateReleaseModal.module.css';

/**
 * Step 1 of the deprecate flow: collect the change justification and run the
 * dry-run. "Authorized By" is intentionally hidden — it is derived from the
 * authenticated user's token (submitted as `deprecatedBy`) and is mandatory; if
 * the session has no valid email the flow is blocked.
 *
 * Presentational: all state and handlers come from the orchestrator via props.
 */
export default function DeprecationForm({
  reason,
  onReasonChange,
  emailValid,
  errorMessage,
  isLoading,
  onSubmit,
}) {
  return (
    <div className={styles.formStep}>
      <OwcTypography className={styles.intro}>
        Deprecation is a destructive operation. Provide the details below and run a{' '}
        <strong>dry-run</strong> to preview the impact before executing. No changes are made during
        the dry-run.
      </OwcTypography>

      {!emailValid && (
        <Banner variant="error">
          Could not determine your account email from the session. Deprecation is unavailable —
          please re-authenticate and try again.
        </Banner>
      )}

      <form onSubmit={onSubmit}>
        <div className={styles.fieldGroup}>
          <div>
            <OwcTypography className={styles.fieldLabel}>Change Justification</OwcTypography>
            <OwcInput
              type="textarea"
              variant="outlined"
              rows={4}
              maxLength={1000}
              show-char-count
              resizable
              placeholder="Reason for deprecation (e.g. Superseded by release 3.0.0)"
              value={reason}
              onInput={(e) => onReasonChange(e.target.value)}
              no-clear-icon
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </form>

      {errorMessage && <Banner variant="error">{errorMessage}</Banner>}

      {isLoading && (
        <div className={styles.progress}>
          <OwcProgressBar size="medium" color="info" indeterminate />
          <div className={styles.progressLabel}>Analyzing impact...</div>
        </div>
      )}
    </div>
  );
}
